<div class="+background-content" appResponsiveCheck #resize="appResponsiveCheck">
    <app-tisco-intro [images]="bImages" [imagesMobile]="bImagesMobile" [title]="bTitle" [description]="bDescription"></app-tisco-intro>
    <div class="uk-section uk-container">
        <div uk-grid>
            <!--Detail Content-->
            <div class="uk-width-expand@m">
                <div class="uk-grid-small" uk-grid>
                    <!--
                    <div class="uk-width-auto uk-visible@m" style="width: 40px;">
                        <ul uk-sticky="offset: 72; bottom: #top-share-stop; cls-inactive: stick" class="uk-list uk-margin-remove-bottom +icon-social">
                            <li>แชร์</li>
                            <li class="uk-margin-small-bottom">
                                <a href="#"><img src="/assets/images/icon/facebook-black.svg" alt="facebook"/></a>
                            </li>
                            <li class="uk-margin-small-bottom">
                                <a href="#"><img src="/assets/images/icon/social-twitter.svg" alt="twitter"/></a>
                            </li>
                            <li class="uk-margin-small-bottom">
                                <a href="#"><img src="/assets/images/icon/social-line.svg" alt="Line"/></a>
                            </li>
                        </ul>
                    </div>
                    -->
                    <div class="uk-width-expand@m">
                        <div class="+text-read">
                            <h3>ระยะเวลารอคอยโรค คืออะไร?</h3>
                            <p>ระยะเวลารอคอย หรือ Waiting Period คือ ช่วงเวลาที่ผู้เอาประกันภัยเข้ารับการรักษาพยาบาล แต่ไม่สามารถเรียกร้องค่าสินไหมได้ เพราะอาจมีอาการเจ็บป่วยมาก่อนทำประกัน</p>
                            <p>เหตุนี้ประกันสุขภาพจึงมีการกำหนดระยะเวลารอคอย เพื่อลดความเสี่ยงของบริษัทประกันภัยไม่ให้ผู้ที่เจ็บป่วยมาก่อนทำประกันภัยเพื่อจะมาเรียกร้องสินไหมในส่วนของค่ารักษาพยาบาลได้</p>
                            <h3>การกำหนดระยะเวลารอคอยขึ้นอยู่กับ</h3>
                            <p>ขึ้นอยู่กับเงื่อนไขของบริษัทประกันภัย อาจจะมีความแตกต่างกันไป ตามแบบประกันภัย แนะนำว่าควรทำความเข้าใจในรายละเอียดความคุ้มครองและเงื่อนไข ก่อนตัดสินใจทำประกันภัยทุกครั้ง</p>
                            <p>ในช่วงนั้นคุณตาลใช้ชีวิตอย่างเต็มที่ เธอชอบท่องเที่ยว เมื่อชีวิตเริ่มอยู่ตัว จึงออก เดินทางไปท่องเที่ยวทั้งในและนอกประเทศ แต่เธอไม่ให้ความสำคัญกับการดูแลตัว เองเท่าไรนัก นอนดึก ตื่นสาย ไม่ออกกำลังกาย กินอาหารตามใจปาก ไม่สนว่า
                                จะมีประโยชน์หรือไม่ ถ้าอยากกินก็กินเลย โดยเฉพาะอาหารประเภทปิ้งย่าง รวมถึง อาหาร junk food ทั้งหลายที่เธอยกให้เป็นเมนูโปรดในดวงใจ</p>
                        </div>
                        <hr id="top-share-stop" />
                        <!--
                        <div class="uk-text-right uk-margin-medium-bottom uk-hidden@m +icon-social">
                            <span class="uk-padding-small">แชร์</span>
                            <span class="uk-margin-small-right">
                                <a href="#"><img src="/assets/images/icon/facebook-black.svg" alt="facebook" /> </a>
                            </span>
                            <span class="uk-margin-small-right">
                                <a href="#"><img src="/assets/images/icon/social-twitter.svg" alt="twitter" /></a>
                            </span>
                            <span>
                                <a href="#"><img src="/assets/images/icon/social-line.svg" alt="Line" /></a>
                            </span>
                        </div>
                        -->
                    </div>
                    <section class="uk-section calculate-card">
                        <div class="uk-margin-small-bottom calculate-card.box">
                            <app-tisco-block-calculate-link></app-tisco-block-calculate-link>
                        </div>
                    </section>
                </div>
            </div>
            <div class="uk-width-1-3@m">
                <h2>เรื่องอื่นๆ ที่เกี่ยวข้อง</h2>
                <ul class="uk-list">
                    <li class="uk-margin">
                        <div class="uk-grid-collapse uk-child-width-expand@s" uk-grid>
                            <div class="uk-width-1-4 uk-padding-remove uk-border-rounded uk-overflow-hidden">
                                <img src="/assets/images/blogs/garlic-property.jpg" alt="กระเทียม สมุนไพรพื้นบ้านของไทย" />
                            </div>
                            <div class="uk-width-expand">
                                <div class="uk-padding-remove-vertical uk-padding-remove-right uk-padding-small">
                                    <h4 class="uk-margin-remove-bottom">
                                        <a [routerLink]="['/blog/', '02']">รู้หรือไม่! ว่ากระเทียมมีสรรพคุณที่ไม่คาดคิด</a>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </li>
                    <li class="uk-margin">
                        <div class="uk-grid-collapse uk-child-width-expand@s" uk-grid>
                            <div class="uk-width-1-4 uk-padding-remove uk-border-rounded uk-overflow-hidden">
                                <img src="/assets/images/blogs/cancer-exercise.jpg" alt="ผู้ป่วยมะเร็ง ออกกำลังกายอย่างไรดี" />
                            </div>
                            <div class="uk-width-expand">
                                <div class="uk-padding-remove-vertical uk-padding-remove-right uk-padding-small">
                                    <h4 class="uk-margin-remove-bottom">
                                        <a [routerLink]="['/blog/', '03']">ผู้ป่วยมะเร็ง ออกกำลังกายอย่างไรดี ?</a>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </li>
                    <li class="uk-margin">
                        <div class="uk-grid-collapse uk-child-width-expand@s" uk-grid>
                            <div class="uk-width-1-4 uk-padding-remove uk-border-rounded uk-overflow-hidden">
                                <img src="/assets/images/blogs/cancer-thai.jpg" alt="มะเร็ง โรคร้ายอันดับ1 คร่าชีวิตคนไทยและทั่วโลก" />
                            </div>
                            <div class="uk-width-expand">
                                <div class="uk-padding-remove-vertical uk-padding-remove-right uk-padding-small">
                                    <h4 class="uk-margin-remove-bottom">
                                        <a [routerLink]="['/blog/', '04']">มะเร็ง โรคร้ายอันดับ1 คร่าชีวิตคนไทยและทั่วโลก</a>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </li>
                    <li class="uk-margin">
                        <div class="uk-grid-collapse uk-child-width-expand@s" uk-grid>
                            <div class="uk-width-1-4 uk-padding-remove uk-border-rounded uk-overflow-hidden">
                                <img src="/assets/images/blogs/women-cancer.jpg" alt="การดื่มแอลกอฮอล์เสี่ยงเป็นมะเร็งเต้านม" />
                            </div>
                            <div class="uk-width-expand">
                                <div class="uk-padding-remove-vertical uk-padding-remove-right uk-padding-small">
                                    <h4 class="uk-margin-remove-bottom">
                                        <a [routerLink]="['/blog/', '05']">สาวนักดื่มรู้หรือไม่ การดื่มแอลกอฮอล์เสี่ยงเป็นมะเร็งเต้านม</a>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="uk-section">
        <div class="uk-container">
            <h2 class="uk-margin-bottom">เรื่องอื่นๆ ที่คุณอาจสนใจ</h2>
        </div>
        <div class="uk-container" [ngClass]="{'uk-padding-remove': !resize.responsiveCheck, '': resize.responsiveCheck}">
            <ng-container *ngIf="!resize.responsiveCheck">
                <!-- for mobile -->
                <div class="uk-position-relative uk-visible-toggle uk-overflow-container" tabindex="-1" uk-slider="finite: true;">
                    <ul class="uk-slider-items uk-grid uk-grid-small uk-padding-small uk-padding-remove-horizontal uk-padding-remove-top" uk-height-match="target: .uk-card; row: false">
                        <li class="uk-width-4-5 uk-width-1-3@m">
                            <div class="uk-card uk-card-default uk-border-rounded">
                                <div class="uk-card-media-top">
                                    <a [routerLink]="['/blog/', '06']">
                                        <img class="+rounded-top" data-src="/assets/images/blogs/zcp-desktop.jpg" alt="3 เหตุผล..ที่คนไม่ทำประกันมะเร็ง" uk-img/>
                                    </a>
                                </div>
                                <div class="uk-card-body">
                                    <a [routerLink]="['/blog/', '06']">
                                        <h3 class="uk-card-title">3 เหตุผล..ที่คนไม่ทำประกันมะเร็ง</h3>
                                        <p class="uk-padding-large uk-padding-remove-horizontal uk-padding-remove-top +text-read">การตัดสินใจทำประกันมะเร็งไม่ใช่เรื่องง่ายเลย ... มีหลายเหตุผลที่อาจทำให้คนส่วนหนึ่งรู้สึกว่า "ยังไม่จำเป็น" ที่จะต้องรีบทำ</p>
                                    </a>
                                </div>
                                <div class="uk-card-footer uk-flex uk-position-bottom">
                                    <time class="uk-flex-1 uk-text-muted" datetime="2019-11-16 15:09:00">
                                    <i uk-icon="calendar"></i> 16 พ.ย. 2562
                                </time>
                                    <div class="uk-flex-1 uk-text-right">
                                        <a [routerLink]="['/blog/', '06']" class="uk-button uk-button-text ">เพิ่มเติม<span uk-icon="arrow-right"></span></a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="uk-width-4-5 uk-width-1-3@m">
                            <div class="uk-card uk-card-default uk-border-rounded">
                                <div class="uk-card-media-top">
                                    <a [routerLink]="['/blog/', '07']">
                                        <img class="+rounded-top" data-src="/assets/images/blogs/health-desktop.jpg" alt="ประกันสุขภาพตัวท็อป" uk-img/>
                                    </a>
                                </div>
                                <div class="uk-card-body">
                                    <a [routerLink]="['/blog/', '07']">
                                        <h3 class="uk-card-title">ประกันสุขภาพตัวท็อป คัดมาแล้วว่าคุ้ม โดยธนาคารทิสโก้</h3>
                                        <p class="uk-padding-large uk-padding-remove-horizontal uk-padding-remove-top +text-read">จะดีกว่าไหมถ้าการซื้อประกันสุขภาพเป็นเรื่องง่ายเพราะมีคนคัดมาให้คุณแล้ว? มองหาประกันตัวท็อปที่คุ้มค่า ต้อง TISCO Health Protection Advisory</p>
                                    </a>
                                </div>
                                <div class="uk-card-footer uk-flex uk-position-bottom">
                                    <time class="uk-flex-1 uk-text-muted" datetime="2019-11-15 15:09:00">
                                    <i uk-icon="calendar"></i> 15 พ.ย. 2562
                                </time>
                                    <div class="uk-flex-1 uk-text-right">
                                        <a [routerLink]="['/blog/', '07']" class="uk-button uk-button-text ">เพิ่มเติม<span uk-icon="arrow-right"></span></a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="uk-width-4-5 uk-width-1-3@m">
                            <div class="uk-card uk-card-default uk-border-rounded">
                                <div class="uk-card-media-top">
                                    <a [routerLink]="['/blog/', '08']">
                                        <img class="+rounded-top" data-src="/assets/images/blogs/guru-kung-desktop.jpg" alt="ไขปัญหาเรื่องประกันที่คุณอยากรู้" uk-img/>
                                    </a>
                                </div>
                                <div class="uk-card-body">
                                    <a [routerLink]="['/blog/', '08']">
                                        <h3 class="uk-card-title">TISCO Advisory : Talk with Guru</h3>
                                        <p class="uk-padding-large uk-padding-remove-horizontal uk-padding-remove-top +text-read">ไขปัญหาเรื่องประกันที่คุณอยากรู้ ทำไมซื้อประกันสุขภาพ แต่เคลมไม่ได้? ซื้อประกันสุขภาพที่ไหน เบี้ยถูกที่สุด?</p>
                                    </a>
                                </div>
                                <div class="uk-card-footer uk-flex uk-position-bottom">
                                    <time class="uk-flex-1 uk-text-muted" datetime="2019-11-14 15:09:00">
                                    <i uk-icon="calendar"></i> 14 พ.ย. 2562
                                </time>
                                    <div class="uk-flex-1 uk-text-right">
                                        <a [routerLink]="['/blog/', '08']" class="uk-button uk-button-text ">เพิ่มเติม<span uk-icon="arrow-right"></span></a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </ng-container>
            <ng-container *ngIf="resize.responsiveCheck">
                <!-- for desktop -->
                <div class="uk-position-relative uk-visible-toggle" tabindex="-1">
                    <ul class="uk-slider-items uk-grid uk-grid-small" uk-height-match="target: .uk-card; row: false">
                        <li class="uk-width-4-5 uk-width-1-3@m">
                            <div class="uk-card uk-card-default uk-border-rounded">
                                <div class="uk-card-media-top">
                                    <a [routerLink]="['/blog/', '06']">
                                        <img class="+rounded-top" data-src="/assets/images/blogs/zcp-desktop.jpg" alt="3 เหตุผล..ที่คนไม่ทำประกันมะเร็ง" uk-img/>
                                    </a>
                                </div>
                                <div class="uk-card-body">
                                    <a [routerLink]="['/blog/', '06']">
                                        <h3 class="uk-card-title">3 เหตุผล..ที่คนไม่ทำประกันมะเร็ง</h3>
                                        <p class="uk-padding-large uk-padding-remove-horizontal uk-padding-remove-top +text-read">การตัดสินใจทำประกันมะเร็งไม่ใช่เรื่องง่ายเลย ... มีหลายเหตุผลที่อาจทำให้คนส่วนหนึ่งรู้สึกว่า "ยังไม่จำเป็น" ที่จะต้องรีบทำ</p>
                                    </a>
                                </div>
                                <div class="uk-card-footer uk-flex uk-position-bottom">
                                    <time class="uk-flex-1 uk-text-muted" datetime="2019-11-16 15:09:00">
                                    <i uk-icon="calendar"></i> 16 พ.ย. 2562
                                </time>
                                    <div class="uk-flex-1 uk-text-right">
                                        <a [routerLink]="['/blog/', '06']" class="uk-button uk-button-text ">เพิ่มเติม<span uk-icon="arrow-right"></span></a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="uk-width-4-5 uk-width-1-3@m">
                            <div class="uk-card uk-card-default uk-border-rounded">
                                <div class="uk-card-media-top">
                                    <a [routerLink]="['/blog/', '07']">
                                        <img class="+rounded-top" data-src="/assets/images/blogs/health-desktop.jpg" alt="ประกันสุขภาพตัวท็อป" uk-img/>
                                    </a>
                                </div>
                                <div class="uk-card-body">
                                    <a [routerLink]="['/blog/', '07']">
                                        <h3 class="uk-card-title">ประกันสุขภาพตัวท็อป คัดมาแล้วว่าคุ้ม โดยธนาคารทิสโก้</h3>
                                        <p class="uk-padding-large uk-padding-remove-horizontal uk-padding-remove-top +text-read">จะดีกว่าไหมถ้าการซื้อประกันสุขภาพเป็นเรื่องง่ายเพราะมีคนคัดมาให้คุณแล้ว? มองหาประกันตัวท็อปที่คุ้มค่า ต้อง TISCO Health Protection Advisory</p>
                                    </a>
                                </div>
                                <div class="uk-card-footer uk-flex uk-position-bottom">
                                    <time class="uk-flex-1 uk-text-muted" datetime="2019-11-15 15:09:00">
                                    <i uk-icon="calendar"></i> 15 พ.ย. 2562
                                </time>
                                    <div class="uk-flex-1 uk-text-right">
                                        <a [routerLink]="['/blog/', '07']" class="uk-button uk-button-text ">เพิ่มเติม<span uk-icon="arrow-right"></span></a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="uk-width-4-5 uk-width-1-3@m">
                            <div class="uk-card uk-card-default uk-border-rounded">
                                <div class="uk-card-media-top">
                                    <a [routerLink]="['/blog/', '08']">
                                        <img class="+rounded-top" data-src="/assets/images/blogs/guru-kung-desktop.jpg" alt="ไขปัญหาเรื่องประกันที่คุณอยากรู้" uk-img/>
                                    </a>
                                </div>
                                <div class="uk-card-body">
                                    <a [routerLink]="['/blog/', '08']">
                                        <h3 class="uk-card-title">TISCO Advisory : Talk with Guru</h3>
                                        <p class="uk-padding-large uk-padding-remove-horizontal uk-padding-remove-top +text-read">ไขปัญหาเรื่องประกันที่คุณอยากรู้ ทำไมซื้อประกันสุขภาพ แต่เคลมไม่ได้? ซื้อประกันสุขภาพที่ไหน เบี้ยถูกที่สุด?</p>
                                    </a>
                                </div>
                                <div class="uk-card-footer uk-flex uk-position-bottom">
                                    <time class="uk-flex-1 uk-text-muted" datetime="2019-11-14 15:09:00">
                                    <i uk-icon="calendar"></i> 14 พ.ย. 2562
                                </time>
                                    <div class="uk-flex-1 uk-text-right">
                                        <a [routerLink]="['/blog/', '08']" class="uk-button uk-button-text ">เพิ่มเติม<span uk-icon="arrow-right"></span></a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </ng-container>
        </div>
    </div>
</div>